export { default as WModal } from './WModal';